import React, { useEffect, useState } from 'react';
import Drawer from 'react-modern-drawer';
import directoryServices from '../directoryServices';
import Pagination from '../../../components/Header/Pagination';
import { CommonUtilities } from '../../../commonUtils';

export default function AccountSlider(param: any) {

    let [associatedSubclassification, setassociatedSubclassification] = useState<any>([]);
    let [associatedclassification, setassociatedclassification] = useState<any>([]);
    let [SubClassificationtotalRow, setSubClassificationtotalRow] = useState(1);
    let [listSubClassification, setlistSubClassification] = useState<any>([]);
    let [SubClassificationSearch, setSubClassificationSearch] = useState("");
    let [ClassificationtotalRow, setClassificationtotalRow] = useState(1);
    let [listClassification, setlistClassification] = useState<any>([]);
    let [ClassificationSearch, setClassificationSearch] = useState("");
    let [selectedFile, setSelectedFile] = useState<any>(null);
    let [saveStatus, setSaveStatus] = useState(false);
    let [EditValue, setEditValue] = useState<any>([]);
 
    var SubclassFicationPayload = {
        area: "Accounts",
        referenceCode: "",
        text: "",
        pageNumber: 1,
        pagesize: 10
    }

    let classFicationPayload = {
        formArea: "Accounts",
        pageNumber: 1,
        pagesize: 10,
        useFreeText: ""
    }

    const closePage = () => {
        param.onChangeClose(EditValue);        
        EditValue = [];
        setEditValue(EditValue)
    }

    const handleFileChange = (e: any) => {

        console.log(EditValue.logo)
        const file = e.target.files && e.target.files[0];
        var fileName = e.target.files[0].name;
        //console.log(prefix + EditValue.kontactCode + "/" + fileName)
        if (e.target.files) {
            setSelectedFile(file);
            fileName = URL.createObjectURL(file) 
            console.log(fileName)
            setEditValue({ ...EditValue, ...{ logo: fileName } });
        } 
    }

    const handleNameOnChange = (n: any) => {
        classFicationPayload.pageNumber = n.pageNumber;
        classFicationPayload.pagesize = n.pageSize;
        ClassificationListing()
    }

    const handleNameOnChangeSub = (n: any) => {
        SubclassFicationPayload.pageNumber = n.pageNumber;
        SubclassFicationPayload.pagesize = n.pageSize;
        SubClassificationListing()
    }

    const ClassificationListing = () => {
        if (ClassificationSearch.length > 1) {
            classFicationPayload.useFreeText = ClassificationSearch;
        }
        directoryServices.zFreeTextListing(classFicationPayload).then((res) => {
            setlistClassification(res)
            setClassificationtotalRow(res[0] ? res[0].totalRows : 0)
        })
    }

    const ClassificationSave = (e: any) => {

        if (e != false) {

            directoryServices.musicDirectoryCategorySave({ Code: EditValue.code, categoryName: e, categoryType: "Accounts" });
        } else {
            directoryServices.zFreeTextsave({ formArea: "Accounts", useFreeText: ClassificationSearch });
            directoryServices.musicDirectoryCategorySave({ Code: EditValue.code, categoryName: ClassificationSearch, categoryType: "Accounts" });
        }
        
        loadListClassification();

    }

    const SubClassificationListing = () => {

        if (SubClassificationSearch.length > 1) {
            SubclassFicationPayload.text = SubClassificationSearch;
        }
        directoryServices.tagListing(SubclassFicationPayload).then((res) => {
            setlistSubClassification(res)
            setSubClassificationtotalRow(res[0] ? res[0].totalRows : 0)
        })

    }

    const SubClassificationSave = (e: any) => {

        if (e != false) {
            directoryServices.musicDirectoryCategorySave({ Code: EditValue.code, categoryName: e, categoryType: "Accounts" });
        } else {
            directoryServices.tagSave({ area: "Accounts", code: SubClassificationSearch, id: 0, isActive: 1, isCustom: 1, referenceCode: EditValue.code, text: SubClassificationSearch });
            //directoryServices.musicDirectoryCategorySave({Code:EditValue.code , categoryName:ClassificationSearch,categoryType:"Accounts"} );
        }

        loadListClassification();
    }

    const deleteSubTaging = (e: any) => {
        directoryServices.tagdelete(e).then((res) => {
            SubclassFicationPayload.referenceCode = EditValue.code;
            directoryServices.tagListing(SubclassFicationPayload).then((res) => {
                setassociatedSubclassification(res)
            })

        })
    }

    const deleteTaging = (e: any) => {
        directoryServices.musicDirectoryCategoryDelete(e).then((res) => {

            directoryServices.musicDirectoryCategoryListing({ code: EditValue.code, CategoryType: "Accounts" }).then((res) => {
                setassociatedclassification(res)
            })
        })
    }

    const SaveAsset = () => { 

        directoryServices.saveAccountImage(selectedFile, EditValue.fullName).then((res) => { 

            directoryServices.saveAccount({
                "fullName": EditValue.fullName, "code": EditValue.fullName , "Name": EditValue.fullName, "digitalServiceProviderId": EditValue.digitalServiceProviderId ? EditValue.digitalServiceProviderId : 0
            }).then(function (data) {
                if (res && (!res.errorCode || !res.ExceptionMessage)) {
                    setSaveStatus(true)
                    //EditValue = res;
                    EditValue.logo = res?.split(',')[1]
                    loadListClassification();
                }
            })

        })
    }

    const loadListClassification = () => { 

        console.log(EditValue.fullName)
        SubclassFicationPayload.referenceCode = EditValue.fullName;        
        directoryServices.tagListing(SubclassFicationPayload).then((res) => {
            setassociatedSubclassification(res)
        })

        directoryServices.musicDirectoryCategoryListing({ code: EditValue.fullName, CategoryType: "Accounts" }).then((res) => {
            setassociatedclassification(res)
        })
    }

    useEffect(() => {

        console.log(param)
        if (param && param.selectedDetail && param.selectedDetail.code) {
            //console.log(param.selectedDetail)
            EditValue = param.selectedDetail;
            setEditValue(EditValue)
            loadListClassification();
            setSaveStatus(true)
        }
    }, [param])

    const EditHandler = (e: any) => {
        var field_name = e.target.name;
        var field_value = e.target.value;
        setEditValue({ ...EditValue, ...{ [field_name]: field_value } });
    }

    return (<>
        <Drawer open={param.open}
            onClose={closePage}
            direction='right'
            className='react-drawer-left'>

            <div className="box ws-6 pull-right allowHscroll allowVscroll full-height-vh">
                <div className="box-header-main "> <h2>New Account</h2> </div>

                <div className="box-content box">

                    <div className="form-format ws-12">
                        <label className="control-label text-left">Account Name*</label>

                        <div className="label-entries ws-12">
                            <div className="ws-10">
                                <input type="text" id="Contact" name="fullName" onChange={EditHandler}
                                    placeholder="Account Name" value={EditValue && EditValue.fullName ? EditValue.fullName : ''} />
                            </div>
                        </div>
                    </div>

                    {<div className="ws-12 mtl" >
                        <label className="control-label text-left ws-12 mt text-bold">Account Image</label>
                        <div className="ws-12 pm mb">
                            <div className="ws-4">  

                                {(EditValue.logo) && <div className="box shadowCoverPicture shadow">
                                    <div className="coverPicture">
                                        <img src={"data:image/jpeg;base64,"+EditValue.logo} />
                                    </div>
                                </div>}

                                {!(EditValue.logo) && <table className="box coverPictureContainer shadow">
                                    <tbody><tr>
                                        <td style={{ verticalAlign: "middle" }}>
                                            <i className="icon-new-registration fullImage"></i>
                                        </td>
                                    </tr></tbody>
                                </table>}
                            </div>


                            <div className="ws-7 pm pull-right">
                                <label className="btn-primary" style={{ marginTop: "15%" }}>Upload Image
                                    <input type="file" accept="image/*" id="file-upload" className="hide" onChange={handleFileChange} />
                                </label>

                                <span className="ws-12 mt">Maximum file size 2mb file types accepted .jpg/ .png/ .bmp (Resolution Minimum 300px X 230px).</span>
                            </div>
                        </div>
                    </div>}

                    {(saveStatus) && <div className='ws-12'>
                        {<div className="form-format ws-12 mtl box pLarge" >
                            <label className="control-label text-left">Classification</label>
                            <div className="label-entries ws-12">
                                <div className="ws-8">
                                    <input type="text" value={ClassificationSearch} placeholder="Type to search for classification" onChange={(e) => setClassificationSearch(e.target.value)} />
                                </div>
                                <div >
                                    <button className="btn-success btn-xs pl pr pts" onClick={() => ClassificationListing()}>
                                        <i className="icon-search"></i>
                                    </button>
                                </div>
                                {(ClassificationSearch.length > 3) && <div>
                                    <button className="btn-success btn-xs pl pr pts" onClick={() => ClassificationSave(false)}>
                                        <i className="icon-save"></i>
                                    </button>
                                </div>}
                            </div>

                            <div className="ws-12">
                                <table className="table ml w-76">
                                    <tbody>
                                        {listClassification?.map((values: any) => {
                                            return (
                                                <tr>
                                                    <td width="20%"> <input type="checkbox" onClick={() => ClassificationSave(values.useFreeText)} /> </td>
                                                    <td>{values.useFreeText}</td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>

                                </table>

                                {(() => {
                                    if (ClassificationtotalRow && ClassificationtotalRow > 10) {
                                        return <Pagination onChange={handleNameOnChange} totalRows={ClassificationtotalRow} />
                                    }
                                })()}

                            </div>

                            {(associatedclassification.length > 0) && <div className="form-format ws-12 mtl" ng-show="directoryClassifications.length > 0">
                                <label className="control-label text-left w-30 mt">Associated Classification(s):</label>
                                {associatedclassification?.map((values: any, index: any) => {

                                    return (
                                        <>
                                        <a className="btn ms ps" style={{ background: CommonUtilities.chartColors[index], color: "RGB(255,255,255)" }}>
                                            <span className="mts mb text-center" style={{ color: "#fff" }}>{values.categoryName}</span>
                                            <span className="pull-right mtss" onClick={() => deleteTaging(values.creatorCategoryId)}>
                                                <i className="icon-close1 text-s ms pls" style={{ color: "#fff" }}></i>
                                            </span>
                                        </a>
                                        </>
                                    )
                                })}
                            </div>}
                            {(ClassificationtotalRow == 0) && <div className="label-entries ws-8">
                                <div className="alert alert-info">No classification available  </div>
                            </div>}

                        </div>}

                        {<div className="form-format ws-12 mtl box pLarge">
                            <label className="control-label text-left">Sub Classification</label>
                            <div className="label-entries ws-12">
                                <div className="ws-8">
                                    <input type="text" value={SubClassificationSearch} placeholder="Type to search for Sub classification" onChange={(e) => setSubClassificationSearch(e.target.value)} />
                                </div>
                                <div >
                                    <button className="btn-success btn-xs pl pr pts" onClick={() => SubClassificationListing()}>
                                        <i className="icon-search"></i>
                                    </button>
                                </div>
                                {(SubClassificationSearch.length > 3) && <div>
                                    <button className="btn-success btn-xs pl pr pts" onClick={() => SubClassificationSave(false)}>
                                        <i className="icon-save"></i>
                                    </button>
                                </div>}
                            </div>

                            <div className="ws-12">
                                <table className="table ml w-76">
                                    <tbody>
                                        {listSubClassification?.map((values: any) => {
                                            return (
                                                <tr>
                                                    <td width="20%"> <input type="checkbox" onClick={() => SubClassificationSave(values.code)} /> </td>
                                                    <td>{values.code}</td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>

                                </table>

                                {(() => {
                                    if (SubClassificationtotalRow && SubClassificationtotalRow > 10) {
                                        return <Pagination onChange={handleNameOnChangeSub} totalRows={SubClassificationtotalRow} />
                                    }
                                })()}

                            </div>

                            {(associatedSubclassification.length > 0) && <div className="form-format ws-12 mtl">
                                <label className="control-label text-left w-30 mt ">Associated Sub Classification(s):</label>

                                {associatedSubclassification?.map((values: any, index: any) => {
                                    return (
                                        <div>
                                            <a className="btn ms ps" style={{ background: CommonUtilities.chartColors[index], color: "#fff" }}>
                                                <span className="mts mb text-center" style={{ color: "#fff" }}>{values.text}</span>
                                                <span className="pull-right mtss" onClick={() => deleteSubTaging(values.id)}>
                                                    <i className="icon-close1 text-s ms pls" style={{ color: "#fff" }}></i>
                                                </span>
                                            </a>
                                        </div>
                                    )
                                }) }
                            </div>}

                            {(SubClassificationtotalRow == 0) && <div className="label-entries ws-8">
                                <div className="alert alert-info">No Subclassification available</div>
                            </div>}

                        </div>}
                    </div>}

                    <div className="box-footer">
                        <div className="pull-right">
                            <button className="btn btn-success" onClick={SaveAsset}> <i className="icon-save"></i> Save  </button>
                            <button className="btn-pink pull-right" onClick={() => closePage()}> <i className="icon-close"></i> Close </button>
                        </div>

                    </div>
                </div>
            </div>
        </Drawer>
    </>)
}